/**
 * Login page
 */
import React from 'react';
import ReactDOM from 'react-dom';
import getContentRoot from './utils/getContentRoot';
import Window from '../../components/Window';
import getTranslations from './utils/getTranslations';
import theme from '../../themes/acura';
import { parseData as parseCmsData } from './api/cms';
import parseLayoutCmsData from './utils/parseLayoutCmsData';
import readConfigData from './utils/readConfigData';
import AcuraResponsiveLayout from '../../components/AcuraResponsiveLayout';
import geo from '../../lib/geo';
import { assign } from 'lodash';

const cmsData = parseCmsData(window.__pageContentData || {});
const appCmsData = {
  ...parseLayoutCmsData(cmsData),
};

const config = readConfigData('acura-config');

const app = assign({}, {
  theme,
  isDesktop: false,
  isMobile: false,
  isResponsive: true,
  modelsNavList: [],
  env: process.env.NODE_ENV,
  version: process.env.VERSION,
  outerContainerId: 'hui-layout-container',
  pageWrapId: 'hui-content-container',
  menuPanelWidth: 390,
  vehiclePanelWidth: 780,
  firstPanelId: 'contentMenu',
  translations: getTranslations(config.language),
}, config, appCmsData);

renderApp(app);
geo.init(app);

function renderApp(props) {
  ReactDOM.render(
    <Window {...props}>
      <AcuraResponsiveLayout {...props}>
        <div id="accountsApp" data-ng-cloak>
          <accounts-app>
            Loading...
          </accounts-app>
        </div>
      </AcuraResponsiveLayout>
    </Window>,
    getContentRoot('root')
  );
}



// WEBPACK FOOTER //
// ./src/apps/acuraca/login.js